import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "task-time-tracker__layout" }
const _hoisted_2 = { class: "task-time-tracker__desc" }
const _hoisted_3 = { class: "task-time-tracker__desc__item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "task-time-tracker__desc__content" }, " Общее потраченное время ", -1)
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "task-time-tracker__desc__item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "task-time-tracker__desc__content" }, " Ваше потраченное время ", -1)
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "task-time-tracker__top-controls" }
const _hoisted_10 = { class: "task-time-tracker__top-controls-buttons" }
const _hoisted_11 = { class: "task-time-tracker__bottom-controls" }
const _hoisted_12 = { class: "task-time-tracker__list-timers" }

import { computed, onMounted, onUnmounted, PropType, ref, watch } from 'vue';
import {
  TirPmPopover,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmInput,
} from 'tir-components';
import { PlayIcon, StopIcon } from 'tir-style-system/icons/outline';
import { TaskTimeRecordModel, TaskTimeCreateRecordModel, TaskTimerEditRecordModel } from './models';
import TaskTimeTrackerRecord from './task-time-tracker-record.vue';
import TaskTimeTrackerConfirmPopover from './task-time-tracker-confirm-popover.vue';
import { UserIcon, UserGroupIcon } from 'tir-style-system/icons/outline';
import { CurrentUser } from 'tir-pm-user-core';
import TirPmTooltipElement from 'tir-pm-tooltip-element/src/tir-pm-tooltip-element.vue';
import { AdapterService } from './adapter';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from './models/GetAccessCurrentUserInQueueTaskByIdResponseModel';

/**Адаптер */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-time-tracker',
  props: {
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
  /**Записи */
  records: {
    type: Array as PropType<Array<TaskTimeRecordModel>>,
    default: [],
  },
  /**Дата старта таймера */
  timerStartDate: {
    type: Date,
  },
  /**Загрузка */
  isLoading: {
    type: Boolean,
    default: false,
  },
  /**Ширина */
  width: {
    type: String,
    default: '25.938rem',
  },
  /**Заблокировано */
  isDisabled: {
    type: Boolean,
    default: false,
  },
  /**Минимальное кол-во минут для сохранения */
  minMinutesToSave: {
    type: Number,
    default: 2,
  },
},
  emits: ["onStart", "onStop", "onCreateRecord", "onDeleteRecord", "onEditRecord", "updateTimer"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const adapter = new AdapterService();

/**События */




const $startConfrimPopover = ref<InstanceType<typeof TaskTimeTrackerConfirmPopover>>();

const $element = ref<HTMLElement>();

const $input = ref<HTMLElement>();

/**Текущая дата */
const currentDate = ref(new Date());

let intervalId: number;
const editRecord = ref<TaskTimerEditRecordModel>();

/**Строка ввода */
const inputValue = ref('');

const createTimeRecordData = ref<TaskTimeCreateRecordModel>();

const isDisabledSave = computed(() => {
  if (editRecord.value)
    return (
      getMinutesBetweenDates(editRecord.value.DateStart, editRecord.value.DateEnd) <
      props.minMinutesToSave
    );
  if (createTimeRecordData.value)
    return (
      getMinutesBetweenDates(
        createTimeRecordData.value.DateStart,
        createTimeRecordData.value.DateEnd,
      ) < props.minMinutesToSave
    );

  return true;
});

const getMinutesBetweenDates = (date1: Date, date2: Date): number => {
  const millisecondsPerMinute = 1000 * 60;
  const diffInMilliseconds = Math.abs(date2.getTime() - date1.getTime());
  return Math.floor(diffInMilliseconds / millisecondsPerMinute);
};

const onSave = () => {
  if (editRecord.value?.DateStart) {
    if (!isDisabledSave.value)
      emit('onEditRecord', new TaskTimerEditRecordModel({ ...editRecord.value }));
    editRecord.value = undefined;
    return;
  }
  if (createTimeRecordData.value) {
    if (!isDisabledSave.value) emit('onCreateRecord', createTimeRecordData.value);
    else createTimeRecordData.value = undefined;
  }
};

const onStartEdit = (record: TaskTimeRecordModel) => {
  if (!record.DateStart || !record.DateEnd) return;
  editRecord.value = new TaskTimerEditRecordModel({
    TimerId: record.TimerId,
    DateStart: record.DateStart,
    DateEnd: record.DateEnd,
  });
  inputValue.value = getDiffTimeStr(record.DateStart, record.DateEnd, false);
  $input.value?.focus();
};

const clearInputValue = () => {
  inputValue.value = '';
  createTimeRecordData.value = undefined;
};

const extractTime = (input: string): { hours: number; minutes: number } | undefined => {
  const timeRegex = /^(\d{1,2}):?(\d{1,2})?$/;
  const match = input.match(timeRegex);

  if (match) {
    const hours = parseInt(match[1], 10); // Первая группа - часы
    let minutes = 0;

    if (match[2]) {
      // Обработка минут
      minutes = match[2].length === 1 ? parseInt(match[2], 10) * 10 : parseInt(match[2], 10);
    }

    return { hours, minutes };
  }

  return; // Если строка не соответствует формату времени
};

const getAdjustedDate = (
  time: { hours: number; minutes: number },
  startDate: Date = new Date(),
): Date => {
  const date = new Date(startDate);

  // Вычитаем часы и минуты из текущей даты
  date.setHours(date.getHours() - time.hours);
  date.setMinutes(date.getMinutes() - time.minutes);

  return date;
};

const onInput = (e: Event) => {
  const input = e.target as HTMLInputElement;
  let value = input.value.replace(/\D/g, ''); // Удаляем все нецифровые символы

  // Убедимся, что длина не превышает 4 символов
  if (value.length > 4) {
    value = value.slice(0, 4);
  }

  // Вставляем двоеточие после второй цифры
  if (value.length > 2) {
    value = value.slice(0, 2) + ':' + value.slice(2);
  }

  // Устанавливаем курсор на правильное место
  const originalLength = input.value.length;
  const cursorPosition = input.selectionStart || 0;

  input.value = value;
  inputValue.value = value;

  if (/^(\d{1,2}:\d{1,2}|\d{1,2})$/.test(value)) {
    if (editRecord.value) {
      editRecord.value = new TaskTimerEditRecordModel({
        ...editRecord.value,
        DateStart: getAdjustedDate(extractTime(value), editRecord.value.DateEnd),
      });
    } else {
      createTimeRecordData.value = new TaskTimeCreateRecordModel({
        DateEnd: new Date(),
        DateStart: getAdjustedDate(extractTime(value)),
      });
    }
  } else {
    if (editRecord.value) editRecord.value.DateStart = undefined;
    createTimeRecordData.value = undefined;
  }

  // Корректируем позицию курсора
  const newLength = input.value.length;
  let newCursorPosition = cursorPosition + (newLength - originalLength);
  if (newCursorPosition > input.value.length) {
    newCursorPosition = input.value.length;
  }
  if (newCursorPosition < 0) {
    newCursorPosition = 0;
  }

  input.setSelectionRange(newCursorPosition, newCursorPosition);
};

const calculateTimeDifference = (
  date1: Date,
  date2: Date,
): { hours: number; minutes: number; seconds: number } => {
  // Получаем разницу в миллисекундах между двумя датами
  const diffInMs = Math.abs(date2.getTime() - date1.getTime());

  // Переводим разницу в часы, минуты и секунды
  const hours = Math.floor(diffInMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.round((diffInMs % (1000 * 60)) / 1000);

  return { hours, minutes, seconds };
};

const formatNumber = (num: number) => {
  return num > 9 ? num.toString() : `0${num}`;
};

const getDiffTimeStr = (date1: Date, date2: Date, withSeconds: boolean = true) => {
  const { hours, minutes, seconds } = calculateTimeDifference(date1, date2);

  return `${formatNumber(hours)}:${formatNumber(minutes)}${
    withSeconds ? `:${formatNumber(seconds)}` : ''
  }`;
};

const calculateTotalTimeFromRanges = (ranges: { DateStart: Date; DateEnd: Date }[]): string => {
  // Инициализируем общую разницу в миллисекундах
  let totalDiffInMs = 0;

  // Проходим по всем диапазонам и суммируем разницу времени
  ranges.forEach((range) => {
    const { DateStart, DateEnd } = range;
    totalDiffInMs += Math.abs(DateEnd.getTime() - DateStart.getTime());
  });

  // Переводим общую разницу в часы и минуты
  const hours = Math.floor(totalDiffInMs / (1000 * 60 * 60));
  const minutes = Math.floor((totalDiffInMs % (1000 * 60 * 60)) / (1000 * 60));

  // Форматируем строку
  return `${hours}ч. ${minutes}мин.`;
};
/**Личное время затраченное на задачу */
const personalTimeStr = computed(() => {
  const dates = props.records
    .filter((r) => r.Performer?.Id == CurrentUser.Id)
    .reduce((acc, value) => {
      if (value.DateEnd) return [...acc, { DateStart: value.DateStart, DateEnd: value.DateEnd }];
      return acc;
    }, new Array<{ DateStart: Date; DateEnd: Date }>());

  return calculateTotalTimeFromRanges(dates);
});
/**Общее время затраченное на задачу */
const allTimeStr = computed(() => {
  const dates = props.records.reduce((acc, value) => {
    if (value.DateEnd) return [...acc, { DateStart: value.DateStart, DateEnd: value.DateEnd }];
    return acc;
  }, new Array<{ DateStart: Date; DateEnd: Date }>());

  return calculateTotalTimeFromRanges(dates);
});

const timeStr = computed(() => {
  if (editRecord.value) return inputValue.value;
  if (props.timerStartDate) return getDiffTimeStr(props.timerStartDate, currentDate.value, true);

  return inputValue.value;
});

onMounted(() => {
  adapter.onStartTimerEvent().on(() => emit('updateTimer', false));
  adapter.onStopTimerEvent().on(() => emit('updateTimer', true));
  intervalId = setInterval(() => {
    currentDate.value = new Date();
  }, 250);
  $input.value = $element.value?.querySelector('.task-time-tracker__input input');
  if ($input.value) {
    $input.value.addEventListener('input', onInput);
  }
});
onUnmounted(() => {
  if (intervalId) clearInterval(intervalId);
  if ($input.value) {
    $input.value.removeEventListener('input', onInput);
  }
});

__expose({
  clearInputValue,
  $startConfrimPopover,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "task-time-tracker",
    ref_key: "$element",
    ref: $element,
    style: _normalizeStyle({ width: __props.width })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TirPmTooltipElement, null, {
            content: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(UserGroupIcon))
            ]),
            _: 1
          }),
          _createElementVNode("span", {
            textContent: _toDisplayString(allTimeStr.value)
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TirPmTooltipElement, null, {
            content: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(UserIcon))
            ]),
            _: 1
          }),
          _createElementVNode("span", {
            textContent: _toDisplayString(personalTimeStr.value)
          }, null, 8, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(TirPmInput), {
          class: "task-time-tracker__input",
          placeholder: "00:00",
          label: "Введите время или запустите таймер",
          "is-with-hint": false,
          "is-small-size": "",
          "is-disabled": __props.isDisabled || (!!__props.timerStartDate && !editRecord.value),
          "model-value": timeStr.value,
          onEnter: onSave
        }, null, 8, ["is-disabled", "model-value"]),
        _createElementVNode("div", _hoisted_10, [
          (!__props.timerStartDate)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(TirPmButton), {
                  size: _unref(TirPmButtonSizeEnum).Regular,
                  variant: _unref(TirPmButtonVariantEnum).AccentState,
                  "is-disabled": __props.isDisabled,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onStart', false)))
                }, {
                  leftSlot: _withCtx(() => [
                    _createVNode(_unref(PlayIcon))
                  ]),
                  _: 1
                }, 8, ["size", "variant", "is-disabled"]),
                _createVNode(TaskTimeTrackerConfirmPopover, {
                  ref_key: "$startConfrimPopover",
                  ref: $startConfrimPopover,
                  onConfirm: _cache[1] || (_cache[1] = ($event: any) => (emit('onStart', true)))
                }, null, 512)
              ], 64))
            : (_openBlock(), _createBlock(_unref(TirPmButton), {
                key: 1,
                size: _unref(TirPmButtonSizeEnum).Regular,
                variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('onStop')))
              }, {
                leftSlot: _withCtx(() => [
                  _createVNode(_unref(StopIcon))
                ]),
                _: 1
              }, 8, ["size", "variant"]))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_unref(TirPmButton), {
          size: _unref(TirPmButtonSizeEnum).Small,
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          "is-disabled": __props.isDisabled || isDisabledSave.value,
          "is-loading": __props.isLoading,
          onClick: _withModifiers(onSave, ["stop"])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Сохранить ")
          ]),
          _: 1
        }, 8, ["size", "variant", "is-disabled", "is-loading", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.records, (record) => {
          return (_openBlock(), _createBlock(TaskTimeTrackerRecord, {
            userAccess: __props.userAccess,
            record: record,
            key: record.TimerId,
            onOnDelete: ($event: any) => (emit('onDeleteRecord', record.TimerId)),
            onOnEdit: ($event: any) => (onStartEdit(record))
          }, null, 8, ["userAccess", "record", "onOnDelete", "onOnEdit"]))
        }), 128))
      ])
    ])
  ], 4))
}
}

})